export enum FeatureType {
  Env = 'Env',
  Dynamic = 'Dynamic',
}
